import { Form } from 'antd';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import axios from 'axios';
import SearchModal from '../../SearchModal';
import SectionCard from './SectionCard';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import Data from '../../../Data/Data.json';
import { Crypter } from '../../../Functions/Security/Crypter';

const searchClientParam: ParamsPicklist = { CodeAgence: '', Table: 'CLIENT', Colonne1: 'NUMCLI', Colonne2: 'NOMCLI', Colagence: '', Choix: 22 };

export function getVal(raw: any, ...keys: string[]) {
  if (!raw) return undefined;
  for (const key of keys) {
    if (raw[key] !== undefined && raw[key] !== null && raw[key] !== '') return raw[key];
  }
  return undefined;
}

interface KycClientHeaderProps {
  onClientChange: (numcli: string, clientInfo: any | null) => void;
}

// Recherche client seule — la fiche client n'est plus affichée ici en lecture
// seule : elle réapparaît directement modifiable dans l'onglet Demande (champs
// éditables masqués tant que l'utilisateur n'a pas cliqué sur "Modifier").
// Les comptes du client sont gérés séparément dans l'onglet Compte (voir
// KycComptesPanel), pas ici.
export default function KycClientHeader({ onClientChange }: KycClientHeaderProps) {
  const [searchForm] = Form.useForm();

  async function consultClient() {
    const currentNumcli = searchForm.getFieldValue('NUMCLI');
    if (!currentNumcli) return;
    try {
      const response = await axios.get(Data.ApiUrl.GetClient, {
        headers: { CypherNumcli: Crypter.encrypt(currentNumcli), 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      const res = JSON.parse(Crypter.decrypt(response.data));
      const row = res?.Result?.Table?.[0];
      onClientChange(currentNumcli, res?.StatutCode === 200 && row ? row : null);
    } catch {
      onClientChange(currentNumcli, null);
    }
  }

  return (
    <Form form={searchForm} labelAlign="left" autoComplete="off">
      <SectionCard icon={<PersonSearchIcon fontSize="small" />} title="Client concerné" subtitle="Recherchez le client à modifier">
        <SearchModal
          Titre="Recherche Client" label="Client" name="NUMCLI"  Taille1="100%" Taille2="100%"
          data={[]}
          Parametre={searchClientParam}
          ExecuteafterSelect1={consultClient}
          form={searchForm}
        />
      </SectionCard>
    </Form>
  );
}
